import Vue from "vue";
import Vuex from "vuex";

import Axios from "axios";

import { parseJWT } from "../util";
import hash from "object-hash";

import userModule from "./user.module";

Vue.use(Vuex);
const api_url = "https://roots.jordyboer.nl";

const actions = {
  login(context, { username, password }) {
    return new Promise((resolve, reject) => {
      Axios.post(api_url + "/login", { username, password })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error.response.status);
        });
    });
  },
  register(context, { username, password }) {
    return new Promise((resolve) => {
      Axios.post(api_url + "/users", { username, password }).then(() => {
        resolve();
      });
    });
  },
  getRecipes({ commit }) {
    Axios.get(api_url + "/recipes").then(({ data }) => {
      commit("setRecipes", data.recipes);
    });
  },
  getRecipeById(context, recipeId) {
    return new Promise(async (resolve) => {
      const { data } = await Axios.get(api_url + "/recipes/" + recipeId);
      data.steps.sort((a, b) => +a.order - +b.order);
      data.steps = data.steps.map((step) => {
        step.hash = hash(step);
        return step;
      });

      resolve(data);
    });
  },
  saveRecipe(context, recipe) {
    return new Promise(async (resolve) => {
      await Axios.post(api_url + "/recipes", { ...recipe });
      resolve();
    });
  },
  async updateRecipe(context, recipe) {
    await Axios.post(api_url + "/recipes/" + recipe.id, recipe);
  },
  async claimRecipe({ getters }, recipe) {
    const result = await Axios.post(`${api_url}/recipes/${recipe.id}/claim`, {
      userId: getters.parsedUsertoken.id,
    });

    return result.data.owner;
  },
  deleteStep(context, stepId) {
    return new Promise(async (resolve) => {
      await Axios.delete(api_url + "/steps/" + stepId);
      resolve();
    });
  },
  deleteIngredient(context, ingredientId) {
    return new Promise(async (resolve) => {
      await Axios.delete(api_url + "/ingredients/" + ingredientId);
      resolve();
    });
  },
};

export default new Vuex.Store({
  state: {
    accessToken: null,
    recipes: [],
    roots_url: "https://roots.jordyboer.nl",
  },
  mutations: {
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
      Axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    },
    setRecipes(state, recipes) {
      state.recipes = recipes;
    },
  },
  actions,
  getters: {
    recipes(state) {
      return state.recipes;
    },
    recipeById: (state) => (id) => {
      return state.recipes.find((recipe) => {
        return recipe.id === id;
      });
    },
    accessToken(state) {
      if (state.accessToken) return state.accessToken;
      else return false;
    },
    parsedUsertoken(state) {
      const token = state.accessToken;
      if (token) {
        return parseJWT(token);
      } else {
        return false;
      }
    },
    userIsAdmin(state) {
      const token = state.accessToken;
      if (token) {
        return parseJWT(token);
      } else {
        return false;
      }
    },
  },
  modules: {
    user: userModule,
  },
});
